var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Drawer', {
    attrs: {
      "width": "400",
      "title": `${_vm.openedMaterial ? '编辑' : '新增'}${_vm.convertedType}`
    },
    model: {
      value: _vm.drawerOpened,
      callback: function ($$v) {
        _vm.drawerOpened = $$v;
      },
      expression: "drawerOpened"
    }
  }, [_c('div', {
    staticClass: "drawer-content"
  }, [_c('Form', {
    ref: "formItem",
    attrs: {
      "model": _vm.formItem,
      "rules": _vm.ruleValidate,
      "label-position": "top"
    },
    nativeOn: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "型号",
      "prop": "model"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入型号..."
    },
    model: {
      value: _vm.formItem.model,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "model", $$v);
      },
      expression: "formItem.model"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "材料名",
      "prop": "name"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入材料名..."
    },
    model: {
      value: _vm.formItem.name,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "name", $$v);
      },
      expression: "formItem.name"
    }
  })], 1), _vm.type === 'raw' ? _c('FormItem', {
    attrs: {
      "label": "用于母液",
      "prop": "usedForSemi"
    }
  }, [_c('i-switch', {
    model: {
      value: _vm.formItem.usedForSemi,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "usedForSemi", $$v);
      },
      expression: "formItem.usedForSemi"
    }
  })], 1) : _vm._e(), _vm.type === 'raw' ? _c('FormItem', {
    attrs: {
      "label": "用于复配",
      "prop": "usedForProduct"
    }
  }, [_c('i-switch', {
    model: {
      value: _vm.formItem.usedForProduct,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "usedForProduct", $$v);
      },
      expression: "formItem.usedForProduct"
    }
  })], 1) : _vm._e(), _vm.type === 'raw' ? _c('FormItem', {
    attrs: {
      "label": "用于工厂",
      "prop": "usedInFactory"
    }
  }, [_c('Select', {
    attrs: {
      "multiple": "",
      "filterable": ""
    },
    model: {
      value: _vm.formItem.usedInFactory,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "usedInFactory", $$v);
      },
      expression: "formItem.usedInFactory"
    }
  }, _vm._l(_vm.factoryList, function (factory) {
    return _c('Option', {
      key: factory._id,
      attrs: {
        "value": factory._id
      }
    }, [_vm._v(_vm._s(factory.name))]);
  }), 1)], 1) : _vm._e(), _vm.type === 'semi' ? _c('FormItem', {
    attrs: {
      "label": "母液标签选择",
      "prop": "tags"
    }
  }, [_c('CheckboxGroup', {
    model: {
      value: _vm.formItem.tags,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "tags", $$v);
      },
      expression: "formItem.tags"
    }
  }, [_c('Checkbox', {
    attrs: {
      "label": "jianshui"
    }
  }, [_vm._v("减水")]), _c('Checkbox', {
    attrs: {
      "label": "baotan"
    }
  }, [_vm._v("保坍")]), _c('Checkbox', {
    attrs: {
      "label": "zaoqiang"
    }
  }, [_vm._v("早强")]), _c('Checkbox', {
    attrs: {
      "label": "6c"
    }
  }, [_vm._v("6碳")])], 1)], 1) : _vm._e(), _vm.type === 'product' || _vm.type === 'semi' ? _c('FormItem', {
    attrs: {
      "label": "类型选择",
      "prop": "series"
    }
  }, [_c('RadioGroup', {
    model: {
      value: _vm.formItem.series,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "series", $$v);
      },
      expression: "formItem.series"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "NAP"
    }
  }, [_c('span', [_vm._v("萘系")])]), _c('Radio', {
    attrs: {
      "label": "PCE"
    }
  }, [_c('span', [_vm._v("酸系")])]), _c('Radio', {
    attrs: {
      "label": "J"
    }
  }, [_c('span', [_vm._v("减胶剂")])]), _c('Radio', {
    attrs: {
      "label": "FSA"
    }
  }, [_c('span', [_vm._v("速凝剂")])])], 1)], 1) : _vm._e(), _c('FormItem', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.handleSubmit('formItem');
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }